import React from 'react'

function Page404() {
  return (
    <div className='justify-center'>Page404</div>
  )
}

export default Page404;